document.addEventListener("Stofind:Locations:Loaded", function () {
  const firstLocationEl = document.querySelector(".sto-location-id-6582c80815e39a00118db727");
  const secondLocationEl = document.querySelector(".sto-location-id-6582ca3515e39a00118db728");
  const thirdLocationEl = document.querySelector(".sto-location-id-65b7b8eb8ee71f0011b398a1");
  const fourthLocationEl = document.querySelector(".sto-location-id-65ba75548ee71f0011b398a5");
  const text = "Lieferzeiten: In 1-3 Werktagen bei Dir.";
  const text2 = "Lieferzeiten: In 3-9 Werktagen bei Dir";
  const text3 = "Lieferzeiten: In 3-9 Werktagen bei Dir";
  const text4 = "Lieferzeiten: In 1-3 Werktagen bei Dir";

  addText(firstLocationEl, text);
  addText(secondLocationEl, text2);
  addText(thirdLocationEl, text3);
  addText(fourthLocationEl, text4)
});

function createTextEl(text) {
  const el = document.createElement('div')
    
  el.innerText = text;
  return el;
}

function addText(el, text) {
  if(!el) return;
  
  el.childNodes[1].after(createTextEl(text));
}